module.exports = __webpack_public_path__ + "static/media/question-circle.c8221a64.svg";